/* eslint-disable react/prop-types */
// Imports
import React from "react";
import QuizQuestionBody from "../../QuizQuestionBody/jsx/index.jsx";
import { useQuiz } from "src/contexts/QuizContext.js";
import QuizButtonBack from "../../QuizButtonBack/jsx/index.jsx";
import QuizButtonClose from "../../QuizButtonClose/jsx/index.jsx";
import FocusTrap from "focus-trap-react";

const QuizPageQuestions = () => {
  const { quizStatus } = useQuiz();
  return (
    <FocusTrap
      active={quizStatus !== "start"}
      focusTrapOptions={{
        initialFocus: false,
      }}
    >
      <div
        tabIndex={1}
        className={`quiz-main ${quizStatus === "start" ? `` : `quiz--started`} ${quizStatus !== "summary" ? `questions--collapsed` : `questions--expanded`} ${quizStatus === "completed" ? `quiz--completed` : ``}`}
      >
        <QuizButtonClose />
        <QuizButtonBack />
        <QuizQuestionBody />
      </div>
    </FocusTrap>
  );
};

export default QuizPageQuestions;
